skrilla.service('objectChangeService', function($q, valuesToWordsService){
    var objects = {};

    var registerObject = function(key, objectName, scope){
        var data = scope[objectName];
        var originalData = {};
        originalData[objectName] = createRawObject(data);
        objects[key] = {originalData: originalData, keysToWatch: [], watchGroup: null, scope : scope, objName: objectName, changedValues: []};
        return objects[key]
    }

    var listenForChange = function(key, callback, objectName){
        var data = objectName == null ? objects[key].scope[objects[key].objName] : findValueInObject(objects[key].scope[objects[key].objName], objectName);
        console.log(data);
        objects[key].keysToWatch = objectKeysAsArray(key, data, objectName || objects[key].objName);
        console.log(objects[key]);
        setupWatchGroup(key, callback);
    }

    function objectKeysAsArray(key, data, objectName){
        var arr = []
        if(isObject(data)) {
            for (var objKey in data) {
                if (isObject(data[objKey])) {
                    arr = arr.concat(objectKeysAsArray(key, data[objKey], objectName + '.' + objKey));
                } else {
                    arr.push(objectName + '.' + objKey);
                }
            }
        }else{
            arr.push(objectName);
        }
        return arr;
    }

    var confirmChanges = function(key, objectName) {
        var deferred = $q.defer();
        var data = objectName == null ? objects[key].scope[objects[key].objectName] : findValueInObject(objects[key].scope, objectName);
        var objKeys = objectKeysAsArray(key, data, objectName);
        changedKeys = [];
        objKeys.forEach(function (objKey) {
            if (hasValueChanged(key, objKey)) {
                changedKeys.push(
                    "<b>" + valuesToWordsService.getWord(objKey) + "</b>" +
                    " - FROM: " + "<span style='color:red;'>" + findValueInObject(objects[key].originalData, objKey) + "</span>" +
                    " TO: " + "<span style='color:green;'>" + findValueInObject(objects[key].scope, objKey) + "</span>" +
                    "<br>"
                );
            }
        });
        if (changedKeys.length > 0) {
            swal({
                    title: "Are you sure you want to make the following changes?",
                    text: changedKeys.join(""),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes!",
                    closeOnConfirm: true,
                    html:true,
                    customClass: 'swal-wide'
                },
                function (isConfirm) {
                    console.log(isConfirm);
                    deferred.resolve(isConfirm);
                });
        }
        else{
            swal("Error!", "You've made no changes (that I know of)", "error");0
            deferred.resolve(false);
        }
        return deferred.promise;
    }

    function createRawObject(data){
        var obj;
        if (isObject(data)) {
            obj = {};
            for(var key in data) {
                obj[key] = createRawObject(data[key]);
            }
        }
        else if(isArray(data) === true){
            obj = [];
            data.forEach(function(val){
                obj.push(createRawObject(val));
            });
        }
        else {
            obj = data;
        }
        return obj;
    }

    /*
     This is a bit of a fuck around - this is due to how watching variables in angular works;
     I call the watchGroup() method to stop the current listener, then call setupWatchGroup()
     to re-establish the listener. I do this so the listener will have the new values.
     */
    function setupWatchGroup(key, callback){
        objects[key].watchGroup = objects[key].scope.$watchGroup(objects[key].keysToWatch, function (newVals, oldVals) {
            for (var i = 0; i < objects[key].keysToWatch.length; i++) {
                if (newVals[i] != oldVals[i]) {
                    //console.log(objects[key].keysToWatch[i] + " has changed.");
                    //Pass in : name of changed key, old value, new value
                    callback(objects[key].keysToWatch[i], oldVals[i], newVals[i]);
                    objects[key].watchGroup();
                    setupWatchGroup(key, callback);
                }
            }
        });
    }

    function isObject(value){ return Object.prototype.toString.call(value) === '[object Object]'; }

    function isArray(value){return value !== undefined && value !== null && value.constructor === Array;}

    function findValueInObject(obj, valueName){
        names = valueName.split(".");
        for(var i = 0; i < names.length; i ++){
            if(obj !== null && obj !== undefined) {
                if(names[i].includes("[") && names[i].includes("]")){
                    var name = names[i].split("[")[0];
                    var index = names[i].split("[")[1];
                    index = index.replace("]", "");
                    obj = obj[name][index];
                }
                else {
                    obj = obj[names[i]];
                }
            }
        }
        return obj;
    }

    var hasValueChanged = function(key, valueName){
        if(objects[key] !== null && objects[key] !== undefined) {
            if (isObject(objects[key].originalData)) {
                var originalData = findValueInObject(objects[key].originalData, valueName);
                var currentData = findValueInObject(objects[key].scope, valueName);
                return !areObjectsEqual(originalData, currentData);
            } else {
                return objects[key].scope[valueName] != objects[key].originalData;
            }
        }
        else{
            return false;
        }
    }

    function areObjectsEqual(obj1, obj2){
        var isEqual = true;
        if(isArray(obj1)){
            if(obj1.length === obj2.length) {
                for (var i = 0; i < obj1.length; i++) {
                    if (isEqual === true) {
                        isEqual = areObjectsEqual(obj1[i], obj2[i]);
                    }
                }
            }
            else{
                isEqual = false;
            }
        }
        else if(isObject(obj1)){
            for(var key in obj1) {
                if(isEqual === true) {
                    isEqual = areObjectsEqual(obj1[key], obj2[key]);
                }
            }
        }
        else{
            isEqual = obj1 == obj2;
        }
        return isEqual;
    }


    var containsUnSavedObjects = function (key) {
        var hasChanged = false;
        if(objects[key] !== null && objects[key] !== undefined) {
            var name = objects[key].objName;
            hasChanged = !areObjectsEqual(objects[key].originalData[name], objects[key].scope[name]);
        }
        return hasChanged;
    }
    var clearObjects = function(key){
        objects[key] = {};
    }

    return {
        registerObject: registerObject,
        hasValueChanged: hasValueChanged,
        listenForChange: listenForChange,
        confirmChanges: confirmChanges,
        clearObjects: clearObjects,
        containsUnSavedObjects: containsUnSavedObjects
    };
});

